import {Component, Vue} from "vue-property-decorator";
import store from '../../../store';
import DatePicker from "vue2-datepicker";
import moment from "moment";
import {SearchService} from '../../services/search.service';
import {Inject} from "inversify-props";
import SearchBody from "@/app/shared/models/search-body.model";
import {Currencies} from "@/app/shared/common/currencies";
import Itinerary from "@/app/shared/models/itinerary.model";
import FaresLister from "@/app/shared/components/credit-fares-lister.component";
import BookDifferentRoute from "@/app/shared/components/credit-book-different.component";
import {solutionTypes} from "@/app/shared/common/constants";
import {TimeService} from '@/app/services/time.service';
import SearchResultPage from '@/app/search-result-page/search-result-page.component';

@Component<CreditInformationFares>({
    components: ({DatePicker, FaresLister, BookDifferentRoute})
})
export default class CreditInformationFares extends Vue {
    @Inject() public readonly searchService: SearchService;
    @Inject() private readonly timeService: TimeService;

    public readonly solutionTypes = solutionTypes;

    public store = store;

    private defaultModalTitle = 'FLIGHTS AVAILABLE TO REBOOK';
    private modalTitle = this.defaultModalTitle;

    private searching = false;
    public travelDates = [];

    private currencies: Currencies;

    private searchResultError = '';
    private searchResultFnf = [];
    private searchResults = [];

    private itineraryId: number = 0;
    private selectedSolutionId: number = 0;

    private searchProgress = 0;

    private showBookDifferentRoute = false;

    private currency: any =   {
        code: this.store.state.currency.code,
        sign: this.store.state.currency.sign,
        rate: this.store.state.currency.rate
    };

    public constructor() {
        super();

        this.currencies = new Currencies(this.searchService);
    }

    public mounted() {
        return true;
    }

    public created() {
        return true;
    }

    public get flights() {
        if (this.$store.state.creditData.credit_data !== null) {
            return this.$store.state.creditData.credit_data.order_flights;
        }
        return [];

    }

    public get orderId() {
        if (this.$store.state.creditData.credit_data !== null) {
            return this.$store.state.creditData.credit_data.order_id;
        }
        return null;
    }

    private getPassengerName(passengerId: number) {
        let name = 'N/A';
        for (let i in this.$store.state.creditData.credit_data.passengers_credit) {
            if (this.$store.state.creditData.credit_data.passengers_credit[i].person_id === passengerId) {
                name = this.$store.state.creditData.credit_data.passengers_credit[i].person_name_full;
                break;
            }
        }
        return name;
    }

    private toggleRebookDifferentRoute(show: boolean) {
        this.showBookDifferentRoute = show;
    }

    private searchNewFares() {
        this.currencies.setCurrent('USD');
        this.$validator.validate()
            .then(valid => {
                if (valid) {
                    this.resetSearch();

                    let itinerary: Itinerary[] = [];
                    let previousDestination: string = '';
                    for (let i in this.flights) {

                        if(previousDestination.length && previousDestination !== this.flights[i]['origin']){
                            itinerary.push(
                                this.itineraryStop(1, '1', previousDestination, '')
                            );
                        }

                        let selectedDeparture = this.selectedDeparture(
                            this.flights[i]['origin'], this.flights[i]['departure_date']
                        );
                        let lastStop = parseInt(i) === this.flights.length - 1 && this.flights.length > 1;
                        if (selectedDeparture || lastStop) {
                            itinerary.push(
                                this.itineraryStop(1, '',
                                    lastStop ? this.flights[i]['destination'] : this.flights[i]['origin'],
                                    lastStop ? '' : moment(this.travelDates[parseInt(i)]).format('DD-MMM-YYYY')
                                )

                            );

                        }
                        if(this.flights.length === 1){
                            itinerary.push(
                                this.itineraryStop(1, '', this.flights[i]['destination'], '')
                            );
                        }
                        previousDestination = this.flights[i]['destination'];

                    }
                    const searchBody: SearchBody = {
                        filters:
                            {
                                airport_change: false,
                                alliance: [],
                                cabin: this.cabin,
                                cluster: true,
                                flexible_dates: false,
                                hub: true,
                                include_nearby: false,
                                round_trip: false
                            },
                        itinerary: itinerary,
                        airlines: store.getters.selectedAirlines,
                        travelers:
                            {
                                A: this.$store.state.selectedAirlineCreditOptions.length || 1,
                                C: 0,
                                I: 0,
                            },
                        currency: this.currencies.getCurrent()
                    };
                    this.searching = true;
                    this.incrementSearchProgress();

                    this.searchService.search(searchBody).then((res: any) => {

                        if (res.data.status === 'error') {
                            if (res.data.response.fnf !== undefined) {
                                this.searchResultFnf = res.data.response.fnf;
                                this.searchResultError = 'fnf'
                            } else {
                                this.searchResultError = 'other'
                            }
                        } else if (res.data.status === 'ok') {
                            this.searchResults = res.data.response;
                            this.itineraryId = res.data.response.itinerary_id;
                            this.selectedSolutionId = 0;

                            store.commit('saveSearch', searchBody);
                            store.commit('saveSearchResults', res.data.response)

                            this.getSolutions(this.itineraryId);
                        }
                        this.modalTitle = 'AVAILABLE FLIGHTS';
                        this.searching = false;
                    });

                } else {
                    return false;
                }
            }).catch(() => {
            return false;
        });

    }

    private itineraryStop(airport: number, byland: string, code: string, departureDate: string){
        return {
            airport: airport,
            byland: byland,
            cc: '',
            city: '',
            class: 'parent',
            code: code,
            departure_date: departureDate,
            country: '',
            currency: '',
            long: 0,
            lat: 0,
            id: 0,
            name: '',
            state: ''
        }
    }

    private resetSearch() {
        this.searchResults = [];
        this.searchResultFnf = [];
        this.searchResultError = '';
        this.modalTitle = this.defaultModalTitle;
        this.searchProgress = 0;
    }

    private incrementSearchProgress() {
        let increment = 0;
        if (this.searchProgress < 10) {
            increment = 5;
        } else if (this.searchProgress < 30) {
            increment = 4;
        } else if (this.searchProgress < 60) {
            increment = 3;
        } else if (this.searchProgress < 60) {
            increment = 2;
        } else {
            increment = 1;
        }
        this.searchProgress += increment;
        setTimeout(this.incrementSearchProgress, 500)
    }

    public notBeforeDate(flightIdx: number) {
        if (flightIdx > 0) {
            let i = flightIdx - 1;
            while (i >= 0) {
                if (this.travelDates[i]) {
                    return moment(this.travelDates[i]);
                }
                i--;
            }
        }
        return moment();
    }

    public notAfterDate(flightIdx: number) {
        let i = flightIdx + 1;
        while (i <= this.travelDates.length) {
            if (this.travelDates[i]) {
                return moment(this.travelDates[i]);
            }
            i++;
        }
        return null;
    }

    private selectedDeparture(origin: string, departureDate: string) {
        return this.$store.state.creditData.credit_lnk_data.departures !== undefined
            && -1 !== this.$store.state.creditData.credit_lnk_data.departures.indexOf(origin + '-' + departureDate);
    }

    private get cabin(){
        return this.$store.state.creditData.credit_lnk_data.cabin ?
            this.$store.state.creditData.credit_lnk_data.cabin : 'Y';
    }

    private goToBooking() {
        store.commit('itineraryId', this.itineraryId);
        store.commit('resultId', this.selectedSolutionId);
        this.$router.push({name: 'booking'});
    }

    private getSolutions(itineraryId: number) {
        this.currencies.getCurrency();
        this.searchService.getSolutions({itinerary_id: itineraryId})
            .then(res => {
                let response = res.data.response;
                store.commit('saveSolutions', response);
                //this.searchResults.solutions = response;
                this.selectedSolutionId = res.data.response.solutions_info.solutions[this.solutionTypes.bestValue].result_id;

                let body = {
                    currency: this.currencies.default,
                    itinerary_id: itineraryId,
                    filter: this.solutionTypes.customize,
                    results_mode: 1
                };

                this.searchService.getResult(`/flights/result/${this.selectedSolutionId}`)
                    .then(async (res) => {
                        let response = res.data.response;
                        let selectedSegments: any[] = this.setSelectedSegments(response.segments_normalized);
                        store.commit('selectSegments', selectedSegments);
                        store.commit(
                            'totalCost',
                            Math.max(0, Math.floor(response.price.total) - store.getters.creditAvailable)
                        )
                        this.currencies.setCurrent(response.currency);
                        this.currencies.commitToStore(store, 'currency');

                        for (let segmentIndex = 0; segmentIndex < res.data.response.segments_normalized.length; segmentIndex++) {

                            let more_options = {
                                result_id: this.selectedSolutionId,
                                chunk_id:
                                    SearchResultPage.getChunkId(
                                        res.data.response.fares,
                                        res.data.response.segments_normalized[segmentIndex].fare_id
                                    ),
                                group_id:
                                    SearchResultPage.getGroupId(
                                        res.data.response.fares,
                                        res.data.response.segments_normalized[segmentIndex].fare_id
                                    )
                            };

                            let responseMoreOptions: any = [];
                            await this.getMoreOptions(
                                more_options,
                                segmentIndex,
                                res.data.response.segments_normalized[segmentIndex].segment_idx,
                                responseMoreOptions
                            );

                        }

                    });

            });
    }

    private setSelectedSegments(normalizedSegments: any) {
        let selectedSegments: any[] = [];

        normalizedSegments.forEach((segment: any) => {
            let stops: any[] = [];
            segment.stops.forEach((stop: any) => {
                stops.push({
                    airline: stop.airline,
                    airline_name: stop.airline_name,
                    airline_img: `/img/airlines/${stop.airline}.png`,
                    departure_city: stop.departure.desc,
                    departure_code: stop.departure.airport,
                    departure_date: this.timeService.dateFormat(stop.departure.date),
                    departure_time: this.timeService.timeFormat(stop.departure.time),
                    flight_duration: this.timeService.flightTimeFormat(stop.duration),
                    arrival_city: stop.arrival.desc,
                    arrival_code: stop.arrival.airport,
                    arrival_date: this.timeService.dateFormat(stop.arrival.date),
                    arrival_time: this.timeService.timeFormat(stop.arrival.time),
                    cabin_class: stop.cabin,
                    bags_recheck_required: stop.bags_recheck_required,
                    layover_time: this.timeService.flightTimeFormat(stop.layover_time)
                });
            });

            selectedSegments.push({
                airline: segment.airline,
                airline_name: segment.airline_name,
                airline_img: `/img/airlines/${segment.airline}.png`,
                departure_date: this.timeService.dateFormat(segment.departure.date),
                departure_time: this.timeService.timeFormat(segment.departure.time),
                arrival_date: this.timeService.dateFormat(segment.arrival.date),
                arrival_time: this.timeService.timeFormat(segment.arrival.time),
                flight_duration: this.timeService.flightTimeFormat(segment.duration),
                price: segment.price,
                stops: stops,
                segment_idx: segment.segment_idx,
                chunk_id: segment.chunk_id,
                fare_id: segment.fare_id
            });

        })

        return selectedSegments;
    }

    /*
    private showFullResultsSet() {
        this.$router.push(`/search-result/${this.itineraryId}/${this.selectedSolutionId}?`);
    }
    */

    private async getMoreOptions(more_options: any, segmentIndex: number, fareSegmentIdx: number, responseMoreOptions: any) {
        return this.searchService.getMoreOptions(more_options)
            .then(async res => {
                let response = res.data.response;
                //this.prevFilteredMoreOptions = this.filteredMoreOptions;
                store.commit('saveMoreOptions', response);
                /*
                if (typeof (response) !== 'string') {
                    await this.pickingResponseValues(response, segmentIndex, fareSegmentIdx);
                    this.moreOptions = [];
                    responseMoreOptions.push(response);
                }

                const segmentRef = this.flightResultResponse.segments_normalized[segmentIndex]; // short-ref

                let currOption: any = {
                    all_flights_duration: this.timeService.flightTimeFormat(segmentRef.duration),
                    all_stops: segmentRef.stops,
                    all_layover_time: '',
                    segments: [],
                    price: segmentRef.price,
                    consolidator: segmentRef.consolidator,
                    id: this.segments[segmentIndex].length
                };

                if (typeof (currOption.all_stops) !== 'number') {
                    currOption.all_stops = currOption.all_stops.length;
                }

                currOption.price.total = (currOption.price.total * this.currencies.getExchangeRate()).toFixed();

                let currSegment = {
                    airline: segmentRef.stops[0].airline,
                    airline_name: segmentRef.airline,
                    airline_img: `/img/airlines/${segmentRef.stops[0].airline}.png`,
                    departure_date: this.timeService.dateFormat(segmentRef.departure.date),
                    departure_time: this.timeService.timeFormat(segmentRef.departure.time),
                    arrival_date: this.timeService.dateFormat(segmentRef.arrival.date),
                    arrival_time: this.timeService.timeFormat(segmentRef.arrival.time),
                    flight_duration: this.timeService.flightTimeFormat(segmentRef.duration),
                    price: segmentRef.price,
                    stops: [],
                    segment_idx: fareSegmentIdx,
                    chunk_id: segmentRef.chunk_id,
                    fare_id: segmentRef.fare_id
                };

                currOption.segments.push(currSegment);

                let stops: any = [];
                let layoverTime: any = 0;
                this.flightResultResponse.segments_normalized[segmentIndex].stops.forEach((stop: any) => {
                    let currStop = {
                        airline: stop.airline,
                        airline_name: stop.airline_name,
                        airline_img: `/img/airlines/${stop.airline}.png`,
                        departure_city: stop.departure.desc,
                        departure_code: stop.departure.airport,
                        departure_date: this.timeService.dateFormat(stop.departure.date),
                        departure_time: this.timeService.timeFormat(stop.departure.time),
                        flight_duration: this.timeService.flightTimeFormat(stop.duration),
                        arrival_city: stop.arrival.desc,
                        arrival_code: stop.arrival.airport,
                        arrival_date: this.timeService.dateFormat(stop.arrival.date),
                        arrival_time: this.timeService.timeFormat(stop.arrival.time),
                        cabin_class: stop.cabin,
                        bags_recheck_required: stop.bags_recheck_required,
                        layover_time: this.timeService.flightTimeFormat(stop.layover_time)
                    };

                    layoverTime = layoverTime + stop.layover_time;
                    switch (currStop.cabin_class) {
                        case 'Y':
                            currStop.cabin_class = 'Economy'
                            break;
                        case 'F':
                            currStop.cabin_class = 'First'
                            break;
                        case 'C':
                            currStop.cabin_class = 'Business'
                            break;
                        default:
                            currStop.cabin_class = 'Economy'
                            break;
                    }
                    stops.push(currStop);
                });

                layoverTime = this.timeService.flightTimeFormat(layoverTime);
                currOption.all_layover_time = layoverTime;

                currOption.segments[0].stops = stops;
                this.segments[segmentIndex].push(currOption);
                 */

            })
    }


}
